import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf7.png';

const NetLossStep3 = ({ previousShownErrors }) => (
  <BannerLayout
    section="FEEDBACK"
    subSection="NET LOSS"
    previousShownErrors={previousShownErrors}
    alertText="Your company generated a net loss."
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        To better understand why your team generated negative net profits, we highly
        recommend that you review your Team Report. You should first review your income
        statement and then leverage the analysis sections (marketing, operating, financing) to
        understand how your team decisions impacted various parts of your income statement.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default NetLossStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/net-loss/step3.js